// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2QKM1","validationTips":"StatementDescriptor_validationTips__pFukq"};